import { atom, useRecoilState, useResetRecoilState } from 'recoil'

const notificationsEnrollAtom = atom({
  key: 'notificationEnroll',
  default: {
    dismissed: false,
    interacted: false,
  },
})

function useNotificationsEnroll() {
  const [notificationEnrollState, setNotificationEnrollState] = useRecoilState(notificationsEnrollAtom)
  const resetNotificationEnrollState = useResetRecoilState(notificationsEnrollAtom)

  return {
    resetNotificationEnrollState,
    setNotificationEnrollState,
    notificationEnrollState,
  }
}

export { useNotificationsEnroll }
